import { render } from "./NewCategoryCard.vue?vue&type=template&id=44e16e1e&scoped=true"
import script from "./NewCategoryCard.vue?vue&type=script&lang=js"
export * from "./NewCategoryCard.vue?vue&type=script&lang=js"

import "./NewCategoryCard.vue?vue&type=style&index=0&id=44e16e1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44e16e1e"]])

export default __exports__